/**
 * Shared access to the site-wide Lenis instance.
 *
 * Lenis is created only in the client SmoothScroll provider. Route changes and
 * modal unlocks call through here so they still work if Lenis is not running
 * (SSR, tests, prefers-reduced-motion fallback).
 */

let lenisInstance = null;

/**
 * @param {import('lenis').default|null} instance
 */
export const setLenisInstance = instance => {
  lenisInstance = instance || null;
};

export const getLenis = () => lenisInstance;

/**
 * Scroll the document. Uses Lenis when it is running; otherwise native scroll.
 *
 * @param {number|string|HTMLElement} target pixel offset, selector, or element
 * @param {Object} [options] Lenis scrollTo options
 */
export const scrollPageTo = (target, options = {}) => {
  if (typeof window === 'undefined') {
    return;
  }

  if (lenisInstance) {
    lenisInstance.scrollTo(target, options);
    return;
  }

  const { immediate = true } = options;
  if (typeof target === 'number') {
    window.scrollTo({ top: target, left: 0, behavior: immediate ? 'auto' : 'smooth' });
    return;
  }

  const el =
    typeof target === 'string' ? document.querySelector(target) : target && target.scrollIntoView ? target : null;
  el?.scrollIntoView({
    block: 'start',
    behavior: immediate ? 'auto' : 'smooth',
  });
};
